import { Grid, Typography, Paper } from '@mui/material';
import { fontSize, fontWeight } from '@mui/system';

const HomePageBanner = ({ text, backgroundColor, link, textColor }) => {
    return (
        <a href={link} style={{"text-decoration": "none"}}>
        <Paper square sx={{ backgroundColor:  backgroundColor , px: 1, py: 1, mt:-4.3 }}>
            <Grid container justifyContent={'center'} textAlign={'center'}>
                <Grid item>
                    <Typography sx={{ color: textColor, fontWeight: 'bold', fontSize: 18 }}>{text}</Typography>
                </Grid>
            </Grid>
        </Paper>
        </a>
    )
}

export default HomePageBanner